import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useEffect, useRef, useState } from 'react';
import {
  AccountOpeningGccOthersViaApplicantType,
  createNationalApplication,
  getAllArabicTypes,
  getAllTypes,
  sendNafathVerificationRequest,
  updateNafath,
} from '../../store/actions/individualAction';
import { setApplicantType } from '../../store/slices/individualSlice';
import { setNafathCode } from '../../store/slices/constantSlice';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { TextWeight, isArabic } = dynamicfunction();
  const { applicantLoading, applicantTypes } = useSelector((state) => state.individual);
  const { authContent } = useSelector((state) => state.content);
  const { authLoading } = useSelector((state) => state.auth);
  const { client_id, nafath_code, client_application_id } = useSelector((state) => state.constant);

  const [showModal, setShowModal] = useState(false);

  const doneRef = useRef(false);
  const mountedRef = useRef(true);
  const timerRef = useRef(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.account_type?.data?.attributes, key, isArabic);
  };

  useEffect(() => {
    if (isArabic) {
      dispatch(getAllArabicTypes());
    } else {
      dispatch(getAllTypes());
    }
  }, []);

  const onsubmit = (values) => {
    dispatch(setApplicantType(values?.applicantType));

    const type_id = values?.applicantType?.id;

    if (type_id === 12 || type_id === 11) {
      let apiData = {
        applicantTypeId: type_id,
        aqamaNumber: '',
        nationalIdNumber: '',
      };
      if (type_id === 12) {
        apiData.aqamaNumber = values?.number;
      }
      if (type_id === 11) {
        apiData.nationalIdNumber = values?.number;
      }

      dispatch(
        createNationalApplication(apiData, () => {
          dispatch(sendNafathVerificationRequest(client_id, () => setShowModal(true)));
        }),
      );
    }
    if (values?.applicantType?.id === 13 || values?.applicantType?.id === 14) {
      const apiData = {
        applicantTypeId: values?.applicantType?.id,
        passportNumber: values?.number,
      };
      dispatch(AccountOpeningGccOthersViaApplicantType(apiData, navigate));
    }
  };

  const closeModal = () => {
    clearTimer();
    setShowModal(false);
    dispatch(setNafathCode(null));
  };

  const clearTimer = () => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (!showModal || doneRef.current) {
      clearTimer();
      return;
    }

    const checkOnce = () => {
      if (doneRef.current || !mountedRef.current) return;

      const apiData = {
        clientApplicationId: Number(client_application_id),
        clientId: client_id,
      };

      dispatch(
        updateNafath(apiData, () => {
          if (doneRef.current || !mountedRef.current) return;

          doneRef.current = true;
          clearTimer();
          dispatch(setNafathCode(null));
          setShowModal(false);
        }),
      );
    };

    // Immediate execution
    checkOnce();

    // Start polling
    timerRef.current = setInterval(checkOnce, 10000);

    // Cleanup on dependency change / unmount
    return () => clearTimer();
  }, [showModal, client_id, dispatch]);

  return {
    TextWeight,
    applicantLoading,
    onsubmit,
    getContentKey,
    applicantTypes,
    navigate,
    isArabic,
    showModal,
    closeModal,
    doneRef,
    nafath_code,
    authLoading,
  };
};
